import { useQuery } from "react-query";

import { dropdownValuesService } from "services";

const useCountriesQuery = () =>
	useQuery("countriesCode", dropdownValuesService.getCountries);

export default useCountriesQuery;
